import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=50ac919c&"
import script from "./MonacoEditor.vue?vue&type=script&lang=ts&"
export * from "./MonacoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports